export enum UserRole {
  B2B = 'B2B',
  B2C = 'B2C',
  Admin = 'Admin'
}

export type B2CIdTokenClaims = {
  extension_Role: UserRole;
  family_name: string;
  given_name: string;
  at_hash: string;
  aud: string;
  auth_time: number;
  email: string[];
  exp: number;
  iat: number;
  iss: string;
  nbf: number;
  nonce: string;
  sub: string;
  tfp: string;
  ver: string;
  extension_CustomerB2BId: string;
};
